



















































import { Component, Vue, Watch } from 'vue-property-decorator';
import AddressBar from '@/components/merchant-list/AddressBar.vue';
import MerchantListItem from '@/components/merchant-list/MerchantListItem.vue';
import ActionTypes from '@/constants/action-types';
import { MerchantModel } from '@/models/MerchantModel';
import { LocationPoint, MerchantsRequest, ShopFilter } from '@/types';
import { getDistanceBetween } from '@/utils/geolocation-utils';
import { Config } from '@/config';
import { SearchMethod } from '@/enums/search-method';
import FilterPopup from '@/components/popups/filter-popup/FilterPopup.vue';
import LocationsMap from '@/components/merchant-list/LocationsMap.vue';

@Component({
  components: {
    LocationsMap,
    FilterPopup,
    MerchantListItem,
    AddressBar,
  },
})
export default class Home extends Vue {
  private isLoading = false;

  private filterPopupOpen = false;

  private showMap = false;

  private bounceId = null;

  private merchantPage = 1;

  mounted(): void {
    if (!this.merchants.length) {
      this.loadMerchants();
    }
  }

  @Watch('location')
  private onLocationChange() {
    this.loadMerchants();
  }

  private async loadMerchants(req?: MerchantsRequest): Promise<void> {
    this.isLoading = true;
    const request = { ...req };

    if (this.location) {
      request.lat = this.location.latitude;
      request.lon = this.location.longitude;
    }

    await this.$store.dispatch(ActionTypes.GetMerchantsPage, request);
    this.isLoading = false;
  }

  private async infiniteScrolling(
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
    isIntersecting: boolean,
  ): Promise<void> {
    if (!entries || !isIntersecting) return;
    const count = this.merchants.length;
    // check if we loaded all merchants
    if (count % Config.MerchantsPageLimit !== 0) {
      return;
    }

    const nextPage = (count / Config.MerchantsPageLimit) + 1;
    await this.loadMerchants({ page: nextPage, limit: Config.MerchantsPageLimit });
  }

  private async showMoreMerchants(
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
    isIntersecting: boolean,
  ): Promise<void> {
    if (!entries || !isIntersecting) return;
    // check if we show all merchants
    if (this.pagedMerchants.length === this.merchants.length) {
      return;
    }
    this.merchantPage += 1;
  }

  private get merchants(): MerchantModel[] {
    return this.$store.getters.filteredMerchantList;
  }

  private get pagedMerchants(): MerchantModel[] {
    return this.merchants.slice(0, this.merchantPage * Config.MerchantsPageLimit);
  }

  private get location(): LocationPoint | null {
    return this.$store.state.location;
  }

  private get searchMethod(): string {
    return this.$store.state.searchMethod;
  }

  private get shopFilter(): ShopFilter {
    return this.$store.state.shopFilter;
  }

  private get activeFiltersCount(): number {
    let count = 0;
    if (this.$store.state.shopFilter.currentlyOpen) {
      count += 1;
    }
    if (this.$store.state.shopFilter.curbsidePickup) {
      count += 1;
    }
    return count;
  }

  private onSearchMethodChange(searchMethod: SearchMethod): void {
    this.$store.commit(ActionTypes.SetSearchMethod, searchMethod);
    if (searchMethod === SearchMethod.SearchByShopName && this.location) {
      this.$store.commit(ActionTypes.SetLocation, null);
      this.loadMerchants();
    }
    if (searchMethod === SearchMethod.SearchByLocation) {
      this.$store.commit(ActionTypes.SetSearchFilter, null);
    }
  }

  private onSearch(value: string): void {
    this.$store.commit(ActionTypes.SetSearchFilter, value);
  }

  private onFilterSave(shopFilter: ShopFilter): void {
    this.$store.commit(ActionTypes.SetShopFilter, shopFilter);
    this.filterPopupOpen = false;
  }

  private distance(merchant: MerchantModel): number | null {
    if (this.location) {
      const merchantLocation: LocationPoint = {
        latitude: parseFloat(merchant.latitude),
        longitude: parseFloat(merchant.longitude),
      };

      return getDistanceBetween(this.location, merchantLocation);
    }
    return null;
  }
}
